module.exports = __webpack_public_path__ + "media/images/card-background-detail-37bb38f5214279f6d59712fb1e5a0d7e.png";